var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.grupper)?_c('div',_vm._l((_vm.grupper),function(hold){return _c('v-row',{key:hold.id,staticClass:"mx-1",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"lg":"8","md":"10","sm":"12","xs":"12"}},[_c('team-card',{attrs:{"hold":hold}})],1)],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }